"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SearchQueryString () {
        return SearchQueryString;
    },
    get SearchQueryStringCsv () {
        return SearchQueryStringCsv;
    }
});
const _zod = require("zod");
const _employee = require("./employee");
const _employeemeetingstats = require("./employee-meeting-stats");
const _meeting = require("./meeting");
const _reviewcyclelog = require("./review-cycle-log");
const _scimlog = require("./scim-log");
const _survey = require("./survey");
const SearchQueryString = _zod.z.discriminatedUnion("service", [
    _employee.EmployeeSearchServiceQueryParams,
    _employeemeetingstats.EmployeeMeetingStatsSearchServiceQueryParams,
    _meeting.MeetingSearchServiceQueryParams,
    _meeting.MeetingWorkspaceSearchServiceQueryParams,
    _reviewcyclelog.ReviewCycleLogSearchServiceQueryParams,
    _scimlog.ScimLogSearchServiceQueryParams,
    _survey.SurveySearchServiceQueryParams,
    _meeting.ActionItemSearchServiceQueryParams
]);
const EmployeeSearchServiceQueryParamsCsv = _employee.EmployeeSearchServiceQueryParams.extend({
    columns: _zod.z.string(),
    fileName: _zod.z.string()
});
const SearchQueryStringCsv = _zod.z.discriminatedUnion("service", [
    EmployeeSearchServiceQueryParamsCsv
]);
